import Vue from 'vue';
import _ from 'underscore';

/**
 * A new copy of Vue instance. All events will be triggered inside
 * @type {Vue}
 */
const Bus = new Vue();

class Event {

	/**
	 * Connecting event to event bus
	 * @param {string} eventName - event name
	 * @param callback - callback of event
	 */
	static connect(eventName, callback) {
		Bus.$on(eventName, callback);
	}

	/**
	 * Disconnecting event from event bus
	 * @param {string[] || string} eventsNames - event name (can be array of event names)
	 */
	static disconnect(eventsNames) {
		if(typeof eventsNames === 'string') {
			Bus.$off(eventsNames);
		} else {
			_(eventsNames).each(event => Bus.$off(event));
		}
	}

	/**
	 * Triggering event inside event bus
	 * @param {string} who - event name
	 * @param {object} argument - object of arguments of event (optional)
	 * @param secondArgument
	 */
	static send(who, argument, secondArgument) {
		Bus.$emit(who, argument, secondArgument)
	}

	/**
	 * Special trigger for toast modal
	 * @param {string} type - type of message (s - success, i - info, e - error, ets.)
	 * @param {string} text - text of message
	 * @param param - custom params if you need (optional)
	 */
	static toast(type, text, param) {
		Bus.$emit('showToast', type, text, param);
	}

	/**
	 * Default method for installing plugin
	 * @param Vue
	 */
	static install(Vue) {
		Vue.prototype.$event = Event;
		Vue.event = Event;
	}
}

export default Event;



// WEBPACK FOOTER //
// ./src/libs/eventBus.js